import { useState } from 'react'
import { Bank, CurrencyCircleDollar, Plus } from '@phosphor-icons/react'

// Hooks
import { useProject } from 'Hooks'

// Component
import { Loading } from 'Organisms/Loading'
import {
  ModalAddBudgetToTask,
  ModalAddTaskToProject,
  SummaryHoursTaskAndBudget,
  TableBudgets,
  TableTasks
} from './Components'

import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import { countDecimalsAndAdd0 } from 'Utils/helperFunctions'

import useSessionStore from 'Context/useSessionStore'

// Const
import { COLOR_BLACK } from 'constant/colors'
import { TabsListTable } from 'Organisms/TabsListTable'
import ModalManageTasksBilling from './Components/ModalManageTasksBilling'

const TABS = {
  TASKS: {
    name: 'Tasks',
    scope: PERMISSION_BY_ROLE.PROJECT.TASK_SECTION.VIEW
  },
  BUDGET: {
    name: 'Budget per task',
    scope: PERMISSION_BY_ROLE.PROJECT.BUDGET_SECTION.VIEW
  }
}

const Tasks = ({ tasks, idProject, refreshProjectInfo, totalSpent, billing, budget }) => {
  const { user } = useSessionStore((state) => ({ user: state.user }))

  const totalBudget = countDecimalsAndAdd0({
    number: tasks.reduce((acc, item) => {
      return acc + (item?.budget || 0)
    }, 0)
  })

  const [activeTab, setActiveTab] = useState(
    PERMISSION_BY_ROLE.PROJECT.TASK_SECTION.VIEW.includes(user.role) ? TABS.TASKS.name : TABS.BUDGET.name
  )
  const [addTaksModal, setAddTaskModal] = useState(false)
  const [addBudgetModal, setAddBudgetModal] = useState(false)

  const { loadingProjectHook, updateTaskProjectRateHook, deleteTaskToProjectHook } = useProject()

  // Inline autosave — the row's RateCell reports its own status, so there's no
  // page-level reload here.
  const handleSaveTaskBillableRate = ({ idTask, value }) =>
    updateTaskProjectRateHook({ idProject, idTask, body: { billable_rate: value ?? 0 } })

  const handleDeleteTaskToProject = async ({ idTask }) => {
    try {
      await deleteTaskToProjectHook({ idTask, idProject })
      await refreshProjectInfo()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      {loadingProjectHook && <Loading />}

      <div className="row justify-content-center tasksbudget">
        <div className="col-lg-11 col-12 d-grid">
          <div className="row">
            <h2 className="mb-3">Tasks</h2>
            <p className='mb-md-4 mb-0'>Manage your project&apos;s tasks, making them available to all your team members.</p>
          </div>

          <div className="row justify-content-end mb-sm-3">
            { (budget?.type === 'Fee per task type' || budget?.type === 'Hours per task type') && (
              <div className="col-sm-auto col-12">
                <button type="button" className="btn btn-secondary" onClick={() => setAddBudgetModal(true)}>
                  <Bank className="icon" size={15} color={COLOR_BLACK} weight="bold" /> <span>Manage budget</span>
                </button>
              </div>
            )}
            { (budget?.type === 'Fee per task type' || budget?.type === 'Hours per task type') && (
              <div className="col-sm-auto col-12">
                <button type="button" className="btn btn-secondary" onClick={() => setAddBudgetModal(true)}>
                  <CurrencyCircleDollar className="icon" size={16} color={COLOR_BLACK} weight="bold" /> <span>Manage billing</span>
                </button>
              </div>
            )}
            <div className="col-sm-auto col-12">
              <button type="button" className="btn btn-primary" onClick={() => setAddTaskModal(true)} id="createTask">
                <Plus className="icon" size={17} color={COLOR_BLACK} weight="bold" /> Add Task
              </button>
            </div>
          </div>

          <div className="card mb-3 p-4">
            {activeTab === TABS.TASKS.name && PERMISSION_BY_ROLE.PROJECT.TASK_SECTION.VIEW.includes(user.role) && (
              <TableTasks
                billing={billing}
                budget={budget}
                tasks={tasks}
                onSaveBillableRate={handleSaveTaskBillableRate}
                onDelete={handleDeleteTaskToProject}
              />
            )}
          </div>
        </div>
      </div>

      {addTaksModal && (
        <ModalAddTaskToProject
          visible={addTaksModal}
          setVisible={setAddTaskModal}
          oldTask={tasks}
          idProject={idProject}
          refreshProjectInfo={refreshProjectInfo}
        />
      )}

      {addBudgetModal && (
        <ModalAddBudgetToTask
          visible={addBudgetModal}
          setVisible={setAddBudgetModal}
          budgetSettings={budget}
          budgets={tasks}
          idProject={idProject}
          refreshProjectInfo={refreshProjectInfo}
        />
      )}
    </>
  )
}

export default Tasks
